import { createFileRoute } from "@tanstack/react-router";
import { sciHead } from "@/lib/science/sci-route";
import { m } from "@/paraglide/messages";
import { CalculatorPage } from "@/tools/countdown-timer/pages/CalculatorPage";

export const Route = createFileRoute("/countdown-timer")({
  ssr: true,
  head: () =>
    sciHead({
      basePath: "/countdown-timer",
      title: m.cd_meta_title(),
      description: m.cd_meta_description(),
      toolName: m.cd_tool_name(),
      faqs: [
        { q: m.cd_faq_q1(), a: m.cd_faq_a1() },
        { q: m.cd_faq_q2(), a: m.cd_faq_a2() },
        { q: m.cd_faq_q3(), a: m.cd_faq_a3() },
        { q: m.cd_faq_q4(), a: m.cd_faq_a4() },
      ],
    }),
  component: CalculatorPage,
});
